<section class="d-flex align-items-center">
    <div class=" section-button d-flex justify-content-center gap-3 ">
        <button id="btn-first" title="Primero" (click)="emitButtonClick($event)"><img id="first"
                src="../../../../../assets/images/icons/flechas-primero.png" alt=""></button>
        <button id="btn-previous" title="Anterior" (click)="emitButtonClick($event)"><img id="previus"
                src="../../../../../assets/images/icons/flecha-anterior.png" alt=""></button>
        <button id="btn-next" title="Siguiente" (click)="emitButtonClick($event)"><img id="next"
                src="../../../../../assets/images/icons/flecha-siguiente.png" alt=""></button>
        <button id="btn-last" title="Ultimo" (click)="emitButtonClick($event)"><img id="last"
                src="../../../../../assets/images/icons/flechas-ultimo.png" alt=""></button>
    </div>
</section>